import type { EmailIntegration } from 'lib-shared-types-api';

export function getEmailIntegrationLabel(
  emailIntegration: EmailIntegration,
): string {
  const emailAddress =
    emailIntegration.spf_sender_email || emailIntegration.email_address || '';
  return emailIntegration.sender_name
    ? `${emailIntegration.sender_name} <${emailAddress}>`
    : emailAddress;
}
